import ModuleManager from './manager'
import Module from './module'
import { install } from './install'

export { Module }
ModuleManager.install = install
ModuleManager.version = '__VERSION__'

export default ModuleManager
